import { SaveOutlined } from "@ant-design/icons"
import { Button, Space } from "antd"

export const DrawerFormButtons = ({ disabled, close, loadingButton, formId }) => {

    return (
        <Space>
            <Button
                form={formId}
                loading={loadingButton}
                icon={<SaveOutlined />}
                type="primary"
                htmlType="submit"
                key="submit"
                disabled={disabled}
            >
                Salva</Button>

            <Button key="close" onClick={close}>Chiudi</Button>
        </Space>
    )
}